import type MDBVegcoBucket from '@/types/vegco/bucket';
import type MDBVegcoCommandeVente from '@/types/vegco/commandevente';
import { emptyMongoId } from '@/utils/helpers';

export function culturesGérées() {
  return ['Iceberg / Pommée', 'Laitue Romaine', 'Laitue Feuille Verte', 'Laitue Feuille Rouge',
     'Bok Choy', 'Nappa', 'Fenouil']
}

export function unitésParBoîte(culture: string | undefined) {
  if (culture == 'Nappa')
    return 12
  return 24
}

export function getBucketBigType(bucket: MDBVegcoBucket | undefined) {
  if (!bucket) {
    return '?'
  }

  if (bucket.codeProduit != '')
    return bucket.codeProduit

  if (bucket.balises.length == 0)
      return '?'

  if (bucket.balises.includes('Wrap') && bucket.balises.includes('Combo') && bucket.balises.includes('Liner')) {
    const buckets = bucket.balises.filter(b => b != 'Wrap' && b != 'Combo' && b != 'Liner')
    buckets.push('Tous')
    return buckets.join('/')
  }

  if (bucket.balises.includes('Frais') && bucket.balises.includes('Coeur') && bucket.balises.includes('Transfo')) {
    const buckets = bucket.balises.filter(b => b != 'Frais' && b != 'Coeur' && b != 'Transfo')
    buckets.push('Tous')
    return buckets.join('/')
  }

  return bucket.balises.join('/')
}

export function getDateCoupéForCulture(commande: MDBVegcoCommandeVente, culture: string) {
  if (commande.dateCoupéManuelle) {
    const dateManuelle = new Date(commande.dateCoupéManuelle)
    if (dateManuelle.getFullYear() > 2000) {
      return dateManuelle
    }
  }

  let date = new Date(commande.dateChargé)
  if (date.getFullYear() <= 2000) {
    date = new Date(commande.dateCréation)
  }

  for (const détail of commande.détails) {
    if (détail.culture == culture) {
      const dateCoupé = new Date(détail.dateCoupé)
      if (dateCoupé < date) {
        date = dateCoupé
      }
    }
  }
  return date
}

export function getFournisseurLettresDappel(fournisseurId: string): string {
  const map: Record<string, string> = {
    '400002': 'Delfland',
    '400003': 'Prod. Horticoles VW',
    '400004': 'JPL Guérin',
    '400005': 'Hotte et Van Winden',
  }
  return map[fournisseurId] ?? fournisseurId
}

export function newVegcoBucket() : MDBVegcoBucket {
  const storeU = useUtilisateurStore();
  return {
    id: emptyMongoId(),
    siteId: storeU.siteSélectionné.id,
    siteGroupeId: storeU.siteSélectionné.id,
    bucketParentId: emptyMongoId(),
    semiId: emptyMongoId(),
    numéroSemi: '',
    semiFermé: false,
    commandeVenteId: emptyMongoId(),
    noCommandeAchat: '',
    date: new Date().toISOString(),
    datePublication: new Date('01/01/1970').toISOString(),
    dateChangéeManuellement: false,
    codeProduit: '',
    culture: '',
    variété: '',
    localisation: '',
    priorité: 50,
    quantité: 0,
    quantitéConfirmée: 0,
    quantitéChangéeManuellement: false,
    quantitéParPalette: 0,
    estPrévision: false,
    balises: [],
    commentaires: '',
    auditId: emptyMongoId(),
    modifiéPar: '',
    valideDu: new Date().toISOString(),
    valideAu: new Date().toISOString(),
    items: []
  } as MDBVegcoBucket
}
